import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Stack,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { NavLink, useNavigate } from "react-router-dom";
import { LoginSchema } from "../../validations/LoginValidation";
import { useAuth } from "../../context/authContext.js";
import { Helmet } from "react-helmet";
import { message } from "antd";

function Login() {
  const navigate = useNavigate();
  // antd message
  const { login } = useAuth();

  // loginData
  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  // password toggle
  const [showPassword, setShowPassword] = useState(false);

  // handle value changes
  const handleChange = (prop) => (event) => {
    setLoginData({ ...loginData, [prop]: event.target.value });
  };

  // toggle password show
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  // Login handler
  const [loading, setLoading] = useState(false);
  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    await LoginSchema.validate(loginData)
      .then(async (value) => {
        await login(loginData);
      })
      .catch((err) => {
        // console.log(err, "err");
        message.error(err.message);
      });
    setLoading(false);
    // console.log("in handleLogin");
  };

  // render

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Click Data-Login</title>
      </Helmet>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100vw",
          height: "100vh",
        }}
      >
        <Paper elevation={10} sx={{ borderRadius: "15px" }}>
          <Stack direction="row">
            <Box style={{ width: "400px", height: "inherit" }}>
              <img
                style={{
                  display: "block",
                  objectFit: "cover",
                  height: "100%",
                  width: "100%",
                  borderRadius: "15px 0 0 15px",
                }}
                src="/images/clicks_login.jpg"
                alt="clicks_login_image"
              />
            </Box>
            <form onSubmit={handleLogin}>
              <Stack spacing={3} px={10} py={5}>
                <Typography variant="h4" align="center">
                  Login
                </Typography>
                <Stack spacing={2}>
                  <TextField
                    label="Email"
                    required
                    size="small"
                    value={loginData.email}
                    onChange={handleChange("email")}
                  />

                  <TextField
                    label="Password"
                    required
                    size="small"
                    type={showPassword ? "text" : "password"}
                    value={loginData.password}
                    onChange={handleChange("password")}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle-password-visibility"
                            onClick={handleClickShowPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Typography variant="body2">
                    Don't have an account?{" "}
                    <NavLink to="/signup">
                      <strong>Signup</strong>
                    </NavLink>
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <LoadingButton
                    variant="contained"
                    fullWidth
                    type="submit"
                    loading={loading}
                    disabled={
                      loginData.email.length > 0 &&
                      loginData.password.length > 0
                        ? false
                        : true
                    }
                  >
                    Login
                  </LoadingButton>
                </Stack>
              </Stack>
            </form>
          </Stack>
        </Paper>
      </Box>
    </div>
  );
}

export default Login;
